module.exports = __webpack_public_path__ + "img/retrospect-102-mobile.ff39eca8.jpg";